import React from "react";
/* 
This component can be changed with three classes. It is expecting a prop {choiceNumber} which is a number that keys into one 
of the className options.

The component is expecting a layout like so:
	<DimensionalDifferenceTwoColumnContainer choiceNumber={3}>
		<div>
			*** Add stuff that goes in the first container here
		</div>
		<div>
			*** Add stuff that goes in the second container here
		</div>
	</DimensionalDifferenceTwoColumnContainer>

Styling will apply to the first and second child of the DimensionalDifferenceTwoColumnContainer, make sure to use divs if adding more 
than one item to a column.
*/
const DimensionalDifferenceTwoColumnContainer = ({ choiceNumber, children }) => {
	const options = {
		1: "ddiff-two-column-right-aligned",
		2: "ddiff-two-column-three-to-one-quarter",
		3: "ddiff-two-column-one-to-three-quarters"
	};
	const className = options[choiceNumber];

	return (
		<div className={className}>
			{children[0]}
			{children[1]}
		</div>
	);
};

export default DimensionalDifferenceTwoColumnContainer;
